export const BLUE = '#038fde';
export const GREEN = '#1e9512';
export const ORANGE = '#ed7837';
export const RED = '#ef0808';
